/*
  cwv-monitoring.js
  ─────────────────
  Real-user Core Web Vitals monitoring. Uses Google's own `web-vitals`
  library (assets/web-vitals.js, vendored — the same measurement code
  Chrome/Lighthouse/CrUX are built on) to capture LCP, CLS, INP, FCP and
  TTFB from actual visitors, and reports them as GA4 events via the
  gtag()/dataLayer already set up sitewide (see gcm-integration-script.liquid).
  No new third-party origin, no new consent surface — same pipe as the
  ecommerce tracking already firing on every page.

  Why: lab tools (PageSpeed, Lighthouse) simulate one throttled device/
  network profile per run and can't tell us what real visitors experience,
  or whether a specific hypothesis (e.g. "a third-party script is stealing
  the LCP candidate") actually happens in the field. The `attribution`
  build used here reports which element/resource caused each metric, not
  just the number, so we can confirm or rule things out from real traffic
  instead of guessing from one-off lab runs.

  Read-only instrumentation: never blocks rendering, never alters layout
  or behavior. Safe to load on every page.
*/
(function () {
  if (!window.webVitals || typeof gtag !== 'function') return;

  function describeTarget(attribution) {
    if (!attribution) return '';
    return (
      attribution.element ||
      attribution.largestShiftTarget ||
      attribution.interactionTarget ||
      ''
    );
  }

  function report(metric) {
    // CLS is a small decimal (e.g. 0.02) — GA4 event params are integers,
    // so scale it up like Google's own analytics.js recipe does.
    var isCLS = metric.name === 'CLS';
    var scale = isCLS ? 1000 : 1;

    gtag('event', 'web_vitals', {
      metric_name: metric.name,
      metric_value: Math.round(metric.value * scale),
      metric_delta: Math.round(metric.delta * scale),
      metric_rating: metric.rating, // "good" | "needs-improvement" | "poor"
      metric_id: metric.id, // stable per page load, lets us dedupe re-reported deltas
      debug_target: describeTarget(metric.attribution),
      page_template: document.body.getAttribute('data-cwv-template') || '',
      non_interaction: true,
    });
  }

  webVitals.onLCP(report);
  webVitals.onCLS(report);
  webVitals.onINP(report);
  webVitals.onFCP(report);
  webVitals.onTTFB(report);
})();
